/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import VersionResponse from '../model/VersionResponse';

/**
* Common service.
* @module api/CommonApi
* @version 1.0
*/
export default class CommonApi {

    /**
    * Constructs a new CommonApi. 
    * @alias module:api/CommonApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instance} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the apiCommonAccountVersionGet operation.
     * @callback module:api/CommonApi~apiCommonAccountVersionGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VersionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/CommonApi~apiCommonAccountVersionGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VersionResponse}
     */
    apiCommonAccountVersionGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = VersionResponse;
      return this.apiClient.callApi(
        '/api/Common/AccountVersion', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiCommonAdminVersionGet operation.
     * @callback module:api/CommonApi~apiCommonAdminVersionGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VersionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/CommonApi~apiCommonAdminVersionGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VersionResponse}
     */
    apiCommonAdminVersionGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = VersionResponse;
      return this.apiClient.callApi(
        '/api/Common/AdminVersion', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }

    /**
     * Callback function to receive the result of the apiCommonVersionGet operation.
     * @callback module:api/CommonApi~apiCommonVersionGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/VersionResponse} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * @param {module:api/CommonApi~apiCommonVersionGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/VersionResponse}
     */
    apiCommonVersionGet(callback) {
      let postBody = null;

      let pathParams = {
      };
      let queryParams = {
      };
      let headerParams = {
      };
      let formParams = {
      };

      let authNames = ['Bearer'];
      let contentTypes = [];
      let accepts = ['text/plain', 'application/json', 'text/json'];
      let returnType = VersionResponse;
      return this.apiClient.callApi(
        '/api/Common/Version', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, null, callback
      );
    }


}
